<div class="cookie-banner" *ngIf="false">
  <div class="cookie-banner__content">
    <div class="cookie-banner__text">
      <h3>{{ 'cookie_banner.title' | transloco }}</h3>
      <p>{{ 'cookie_banner.description' | transloco }}</p>
    </div>
    <div class="cookie-banner__actions">
      <button class="btn btn-secondary" (click)="acceptNecessaryOnly()">
        {{ 'cookie_banner.necessary_only' | transloco }}
      </button>
      <button class="btn btn-primary" (click)="acceptAll()">
        {{ 'cookie_banner.accept_all' | transloco }}
      </button>
    </div>
  </div>
</div>
